<va-filter2-model name="recurring-invoices-list" [filterGroup]="filterGroup" [isLoading]="dataSource.loading$ | async">
  <va-filter-content>
    <mat-card appearance="outlined">
      <ng-container>
        <!-- <mat-progress-bar *ngIf="(dataSource.loading$ | async) === true" mode="indeterminate"></mat-progress-bar> -->
        <table mat-table [dataSource]="dataSource" aria-label="Recurring Invoices">
          <!-- Amount Column -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>{{ 'BILLING.INVOICES_PAGE.RECURRING.AMOUNT' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <strong>
                {{ row.totalAmount | price : row.currencyCode : null : true : false }}
              </strong>
            </td>
          </ng-container>

          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>{{ 'BILLING.INVOICES_PAGE.RECURRING.STATUS' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <ng-container [ngSwitch]="row.status">
                <glxy-badge *ngSwitchCase="RecurringInvoiceStatus.ACTIVE" [color]="'green'" [size]="'normal'">
                  {{ translateStatus(row.status) | translate }}
                </glxy-badge>
                <glxy-badge *ngSwitchCase="RecurringInvoiceStatus.INACTIVE" [color]="'grey'" [size]="'normal'">
                  {{ translateStatus(row.status) | translate }}
                </glxy-badge>
                <glxy-badge
                  *ngSwitchCase="RecurringInvoiceStatus.ARCHIVED"
                  [color]="'dark-grey-solid'"
                  [size]="'normal'"
                >
                  {{ translateStatus(row.status) | translate }}
                </glxy-badge>
              </ng-container>
            </td>
          </ng-container>

          <!-- Customer Column -->
          <ng-container matColumnDef="customer">
            <th mat-header-cell *matHeaderCellDef>{{ 'BILLING.INVOICES_PAGE.RECURRING.CUSTOMER' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <div class="link-layout title">
                <a class="menu-layout" (click)="selectCustomer(row.customerId)">
                  {{ row.customerName || row.customerId }}
                </a>
              </div>
              <div class="subtitle">
                {{
                  {
                    address: row.customerAddress.address,
                    city: row.customerAddress.city,
                    state: row.customerAddress.state
                  } | glxyAddress
                }}
              </div>
            </td>
          </ng-container>

          <!-- Next Invoice Issued -->
          <ng-container matColumnDef="nextIssue">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'BILLING.INVOICES_PAGE.RECURRING.NEXT_INVOICE_ISSUED' | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              {{ row.nextIssue | date }}
            </td>
          </ng-container>

          <!-- Frequency -->
          <ng-container matColumnDef="frequency">
            <th mat-header-cell *matHeaderCellDef>{{ 'BILLING.INVOICES_PAGE.RECURRING.FREQUENCY' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              {{ row.intervalCount | i18nPlural : intervalMapping[row.interval] }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            class="table-row"
            (click)="selectRecurringInvoice(row)"
            *matRowDef="let row; columns: displayedColumns"
          ></tr>
        </table>
      </ng-container>

      <ng-container *ngIf="(length$ | async) === 0 && (dataSource.loading$ | async) === false">
        <glxy-empty-state class="empty-state" [size]="'small'">
          <glxy-empty-state-hero>
            <mat-icon>manage_search</mat-icon>
          </glxy-empty-state-hero>
          <glxy-empty-state-title>
            {{ 'BILLING.INVOICES_PAGE.NO_RESULTS_FOUND_TITLE' | translate }}
          </glxy-empty-state-title>
          <p>
            {{ 'BILLING.INVOICES_PAGE.NO_RESULTS_FOUND_DESCRIPTION' | translate }}
          </p>
        </glxy-empty-state>
      </ng-container>

      <mat-paginator
        #recurringInvoicePaginator
        [length]="length$ | async"
        [pageIndex]="0"
        [pageSize]="25"
        [pageSizeOptions]="[25, 50, 100, 250]"
      ></mat-paginator>
    </mat-card>
  </va-filter-content>
</va-filter2-model>
